import React from 'react'

export default function Layouts403() {
  return (
    <section><a className="anchor" id="forbidden"></a>
      <div className="push--bottom grid">
          <div className="grid__col-sm-12  grid__col-lg-6">
              <a href="samples/forbidden.html"><img src="images/forbidden.png" alt="Screenshot of the theme snippet" className="media__img"/></a>
          </div>
          <div className="media__body soft--top grid__col-sm-12 grid__col-lg-6">
            <h2>403 Error</h2>
            <p>Live example of all the 403 error page.</p>
            <p><a className="btn btn--large" href="samples/forbidden.html">View live preview</a>&nbsp;<a className="btn btn--large" href="samples/forbidden.html" download>Download</a></p>
          </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./styleguide/components/sections/Layouts403.js